import styled, { css } from 'styled-components'

interface IStateProps {
  color: string
  height: number
}

export const State = styled.div<IStateProps>`
  ${(props) =>
    css`
      height: ${props.height}px;
    `}
  display: flex;
  align-items: center;
  svg {
    ${(props) =>
      css`
        color: ${props.color};
      `}
    font-size: 10px !important;
    margin-right: 8px;
  }
`
